import React, { FunctionComponent, useMemo } from 'react';
import { Locale } from '@rbx/intl';
import { Grid } from '@rbx/ui';
import useAppMainConfig from '@modules/ui/shared/hooks/useAppMainConfig';
import { footerID } from '@modules/layout/layout/constants/layoutConstants';
import { creatorHubSettingsPreferencesPageUrl } from '@modules/utilities/constants/baseUrl';
import { PrivateFooter, PublicFooter } from '@rbx/creator-hub-navigation';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';
import useFooterStyles from './Footer.styles';

export interface FooterProps {
  isLandingPage: boolean;
  hasRightNav: boolean;
}

const Footer: FunctionComponent<FooterProps> = ({ isLandingPage, hasRightNav }) => {
  const { locale } = useAppConfig();
  const { mainMaxWidth } = useAppMainConfig();
  const {
    classes: { container, sizeContainer },
    cx,
  } = useFooterStyles({ mainMaxWidth, isLandingPage, hasRightNav });

  const footerBehavior = useMemo(
    () => ({
      showGermanyOnlyLink: locale === Locale.German,
      youTubeLink: 'https://www.youtube.com/@RobloxLearn',
      settingsLink: creatorHubSettingsPreferencesPageUrl,
    }),
    [locale],
  );

  return (
    <Grid
      maxWidth={mainMaxWidth}
      component='footer'
      id={footerID}
      className={cx(container, sizeContainer)}
      item
      container>
      <PublicFooter />
      <PrivateFooter behavior={footerBehavior} />
    </Grid>
  );
};

export default Footer;
